import { state, getters } from './state';
import mutations from './mutations';
import actions from './actions';

export default {
  state,
  getters,
  mutations,
  actions
};
